// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".migration-table{border-radius:8px}.migration-table.el-table td,.migration-table.el-table th{padding:7px 0}.migration-table.el-table th,.migration-table.el-table tr{background:var(--btn-active)}.migration-table.el-table th .cell,.migration-table.el-table tr .cell{font-size:10px}@media(min-width:1280px){.migration-table.el-table th .cell,.migration-table.el-table tr .cell{font-size:12px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
